import type { DistributionPartnerUser } from '@common/api/graphql/getLoginUserGql';
import { useZendeskWidget } from '@common/hooks/useZendeskWidget';
import { hasGon } from '@common/lib/gon';
import { isZendeskWidgetEnabled } from '@common/lib/zendeskWidget';
import type { Gon } from '@console/common/window';
import type { Theme } from '@mui/material';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router';

const styles = (theme: Theme): StyleRules => ({
  button: {
    minWidth: 140,
    position: 'fixed',
    bottom: 20,
    right: 20,
    // 以下は g4b マイページのボタンデザインと合わせるためのもの
    fontSize: 16,
    paddingTop: 12,
    paddingBottom: 12,
    borderRadius: 100,
    fontWeight: 'bold',
    borderColor: theme.palette.primary.main,
    backgroundColor: '#FFFFFF',
    borderWidth: 2,
    '&:hover': {
      borderWidth: 2
    }
  }
});

type OwnProps = WithStyles<typeof styles> & {
  distributionPartnerUser: DistributionPartnerUser;
};

const ZendeskWidget: React.FC<OwnProps> = () => {
  const location = useLocation();
  const isProjectPage = !!matchPath(
    '/console/projects/:urlCode/*',
    location.pathname
  );
  const [zendeskWidgetAccountKey, setZendeskWidgetAccountKey] = useState<
    null | string
  >(null);
  // メッセージスレッドボタンが表示されるプロジェクト配下のページではスクリプトを読み込まない
  useZendeskWidget(isProjectPage ? null : zendeskWidgetAccountKey);

  useEffect(() => {
    if (hasGon<Gon>(window)) {
      if (window.gon.zendeskWidgetAccountKey) {
        setZendeskWidgetAccountKey(window.gon.zendeskWidgetAccountKey);
      }
    }
  }, []);

  useEffect(() => {
    if (!isZendeskWidgetEnabled(window)) return;
    if (isProjectPage) {
      window.zE('messenger', 'hide');
    } else {
      window.zE('messenger', 'show');
    }
  }, [isProjectPage]);

  return null;
};

export default withStyles(styles)(ZendeskWidget);
